"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidHttpStatusClass = void 0;
const tagValues_1 = require("../tagValues");
const isValidHttpStatusClass = (classValue) => {
    return (classValue === tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_2XX ||
        classValue === tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_3XX ||
        classValue === tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_4XX ||
        classValue === tagValues_1.TagValue.API_ENDPOINT_STATUS_CLASS_5XX);
};
exports.isValidHttpStatusClass = isValidHttpStatusClass;
//# sourceMappingURL=httpStatusClass.js.map